module.exports = __webpack_public_path__ + "img/ltkfindsunder50-1x.3d7d815.jpg";